export default {
  messages: {
    required: "هذاالحقل مطلوب",
    email: "يجب أن يكون حقل البريد الإلكتروني بريدًا إلكترونيًا صالحًا",
    numeric: "يجب إدخال قيمة رقمية",
    regex: "صيغة الحقل غير صالحة",
    max: "لا يمكن تجاوز الحد الأقصى المسموح به",
    min: (field, min) => `أقل قيمة مسموحة هي ${min}`,
    digits: (field, digits) => `يجب أن يتكون الحقل من ${digits} رقماً`,
    min_value: "يجب ان تكون قيمة هذا الحقل أعلى من قيمة أقل راتب",
    greater_or_equal:
      "يجب أن تكون قيمة هذا الحقل أكبر أو تساوي قيمة________ الراتب الأقل",
    before: "يجب ألا يكون التاريخ قبل تاريخ اليوم الحالي",
  },
};
